import { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { Box, lighten, Grid, Button, Skeleton, Divider, Tabs, Tab, Paper, Chip } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import AddIcon from '@mui/icons-material/AddRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HouseRoundedIcon from '@mui/icons-material/HouseRounded';
import KeyboardReturnRoundedIcon from '@mui/icons-material/KeyboardReturnRounded';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';


import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import SwitchAccountRoundedIcon from '@mui/icons-material/SwitchAccountRounded';

import { Formik, Form, useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import Field from '../../../utils/FormikFields/Field';

import { BasicFlex, InputLabel } from '../../../utils/Common';

import * as Yup from 'yup';

import { formatCurrency } from '../../../utils/util';

import AutoComplete from '../../../utils/FormikFields/AutoCompleteSolo';

import AutoCompleteFormik from '../../../utils/FormikFields/AutocompleteDebounced';

import { DateTime } from 'luxon';

import Dialog from '../../../utils/utilities/Dialog';

import { useQuery } from '@tanstack/react-query';

import { getServiceCategories } from '../../Services/apiService';

import { getRepairs, findSpecialistsByRepair, getAllRepairCategories, getAllRepairsByVendors } from '../../Repairs/apiService';

import MediaZone from '../../Schedule/Components/MediaZone';

import { useDialogForm } from '../../../contexts/DialogForm';

import { v4 as uuidv4 } from 'uuid';

import useSimpleTable from '../../../hooks/useSimpleTable';

import SearchInput from '../../../utils/utilities/SearchInput';
import AddRounded from '@mui/icons-material/AddRounded';
import { isEmpty, set } from 'lodash';

const MainContainer = styled.div`
  padding: 2rem;
  /* height: 45rem;
  overflow-y: scroll; */
`;

const StepLabel = styled(BasicFlex)`
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0 auto;
  margin-bottom: 1rem;
  background-color: ${props => props.theme.colors.darkBg};
  color: ${props => props.theme.colors.mildText};
  border-radius: 5px;
  padding: 1rem;
`

/* Category styles */

const CategoryContainer = styled(BasicFlex)`
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 2.5rem;
  /* padding: 1rem; */
  width: 100%;
  /* margin: 1rem 0; */
  margin-top: 2rem;
`;

const CategoryTile = styled.div`
  min-width: 160px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: ${props => props.$bg ? lighten(props.$bg, 0.3) : `linear-gradient(135deg, ${lighten(props.theme.colors.secondary, 0.85)} 0%, ${lighten(props.theme.colors.secondary, 0.90)} 100%)`};
  border-radius: 12px;
  /* position: relative; */
  /* overflow: hidden; */
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.18);

  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    
    .icon-wrapper {
      background: rgba(255, 255, 255, 0.5);
      transform: rotate(15deg) scale(1.1);
    }
  }

  &:active {
    transform: translateY(-4px) scale(1.01);
  }
`;

const StyledCardContent = styled(BasicFlex)`
  padding: 2.5rem 1.5rem;
  flex-direction: column;
  gap: 1.5rem;
  position: relative;
  z-index: 1;
`;

const IconWrapper = styled(BasicFlex)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  justify-content: center;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
`;

const CategoryText = styled.div`
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
  min-width: fit-content;
`;

/* End Category styles */


/* Repair Tile Styles */
const RepairMainContainer = styled.div`
  height: 43rem;
  overflow-y: scroll;
`
const SOURCE_CONFIG = {
  inHouse: {
    label: 'In House',
    Icon: HouseRoundedIcon,
  },
  vendor: {
    label: 'Vendor',
    Icon: LocalShippingRoundedIcon,
  },
};
 
const RepairsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
  gap: theme.spacing(1.25),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));
 
const RepairTile = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(1.375, 1.625),
  cursor: 'pointer',
  transition: 'border-color 120ms ease, background-color 120ms ease',
  '&:hover': {
    borderColor: theme.palette.text.disabled,
    backgroundColor: theme.palette.action.hover,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));
 
const RepairName = styled('div')(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  lineHeight: 1.35,
  // minHeight: 37,
  color: theme.palette.text.primary,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));
 
const PriceText = styled('div', {
  shouldForwardProp: (prop) => prop !== 'muted',
})(({ theme, muted }) => ({
  marginTop: theme.spacing(0.875),
  fontSize: muted ? 12.5 : 14,
  fontWeight: muted ? 400 : 400,
  color: muted ? theme.palette.text.hint : theme.palette.text.primary,
}));
 
const MetaRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.625),
  marginTop: theme.spacing(1.125),
  paddingTop: theme.spacing(1),
  borderTop: `1px solid ${theme.palette.divider}`,
  fontSize: 12,
  color: theme.palette.text.hint,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
 
const SourceText = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
}));
 
const TileSkeleton = styled(Skeleton)({
  borderRadius: 12,
  transform: 'none',
});
// const RepairsContainer = styled(BasicFlex)`
//   justify-content: flex-start;
//   flex-wrap: wrap;
//   gap: 2.5rem;
//   width: 100%;
//   margin-top: 2rem;
// `;

// const RepairTile = styled.div`
//   min-width: 160px;
//   cursor: pointer;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   background: ${props => `linear-gradient(135deg, ${lighten(props.theme.colors.secondary, 0.9)} 0%, ${lighten(props.theme.colors.secondary, 0.93)} 100%)`};
//   border-radius: 12px;
//   /* position: relative; */
//   /* overflow: hidden; */
//   box-shadow: 0 3px 5px rgba(0, 0, 0, 0.18);

//   &:hover {
//     transform: translateY(-3px) scale(1.02);
//     box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    
//     .icon-wrapper {
//       background: rgba(255, 255, 255, 0.5);
//       transform: rotate(15deg) scale(1.1);
//     }
//   }

//   &:active {
//     transform: translateY(-2px) scale(1.01);
//   }
// `;

// const InfoBars = styled(BasicFlex)`
//   flex-direction: column;
//   gap: 1rem;
// `

const RepairInfoBar = styled(BasicFlex)`
   background: rgba(255, 255, 255, 0.8);
   padding: 0.5rem .4rem;
   border-radius: 6px;
   justify-content: space-between;
   font-size: 1.2rem;
`;

/* End Repair Tile Styles */

const BackButton = styled(BasicFlex)`
  padding: 0 2rem;
  margin-bottom: 1rem;
`

/* Selected Repair Styles */
  const SelectedRepairContainer = styled(BasicFlex)`
    background-color: ${props => props.theme.colors.secondaryFaint};
    border: 1px solid ${props => props.theme.colors.secondary};
    border-radius: 5px;
    margin-bottom: 2rem;
    align-items: stretch;
  `;
  
  const IconBox = styled(BasicFlex)`
    width: 10rem;
    /* border-radius: 50%; */
    background-color: ${props => props.theme.colors.lightBg};
    justify-content: center;
    /* backdrop-filter: blur(10px); */
    transition: all 0.3s ease;
    border-radius: 5px;
  `;

  const SelectedRepairInfo = styled(BasicFlex)`
  margin-bottom: .5rem;
    &.name {
      font-weight: 600;
      font-size: 1.6rem;
      margin-bottom: 1rem;
    }
  `;

  const SelectedRepairInfoContainer = styled.div`
    padding: 1rem 0;
  `
/* End Selected Repair Styles */

/* */
  const FilterChip = ({label, value, sf, lf}) => {
    let val = lf?.in_house;
    let selected = val === value || (value === 'all' && val === undefined);
    return (
      <Chip variant="outlined" label={label} size="small" onClick={() => sf(value)} color={selected ? "secondary" : "default"} />
    )
  }
/* */


const Categories = ({  onCategorySelect, moveStep, activeTab, setActiveTab }) => {
  // const [activeTab, setActiveTab] = useState("categories");
  const handleCategoryClick = (category) => {
      onCategorySelect(category);
      moveStep();
  };

  const { data: categories, isLoading } = useQuery({
    queryKey: ['categories', activeTab],
    queryFn: () => getAllRepairCategories(activeTab),
    // staleTime: Infinity
  })

  const { data: categoryList, pagination, setPagination, setSearchTerm } = useSimpleTable({localData: categories, rowsPerPage: 100, searchFields: ["name"], defaultSort: "name"});

  return (
    <>
    <BasicFlex justify="flex-end" my="1rem">
      <Button endIcon={<ArrowRightAltRoundedIcon />} onClick={() => moveStep()}>View All Repairs</Button>
    </BasicFlex>
    <Paper elevation={2} sx={{mt: ".5rem", mb: "1.5rem", pb: "0" }} square>
      <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} variant='fullWidth'>
        <Tab value="categories" icon={<CategoryRoundedIcon fontSize='small' />} iconPosition="start" label="By Category" sx={{   minHeight: "5rem"}} />
        <Tab value="vendors" icon={<SwitchAccountRoundedIcon fontSize='small' />} iconPosition="start" label="By Vendor" sx={{  minHeight: "5rem"}} />
      </Tabs>
    </Paper>
      <SearchInput onChange={(e) => setSearchTerm(e.target.value)} fieldsToSearch={["Category Name"]} />
      <CategoryContainer>
        {isLoading ? (<>
          <Skeleton variant="rounded" width={160} height={180} />
          <Skeleton variant="rounded" width={160} height={180} />
          <Skeleton variant="rounded" width={160} height={180} />
          <Skeleton variant="rounded" width={160} height={180} />
          <Skeleton variant="rounded" width={160} height={180} />
        </>) : categoryList?.rows?.map((category, index) => (
          <CategoryTile 
            key={category.name}
            onClick={() => handleCategoryClick(category)}
            $bg={category.label_color}
          >
            <StyledCardContent>
              <IconWrapper className="icon-wrapper">
                <AutoFixHighRoundedIcon sx={{ fontSize: 28 }} color="basic" />
              </IconWrapper>
              <CategoryText>
                {category.name}
              </CategoryText>
            </StyledCardContent>
          </CategoryTile>
        ))}
      </CategoryContainer>
    </>
  );
};


const InfoBar = ({ Icon, title, value }) => {
  return (
    <RepairInfoBar gap="5rem">
       <BasicFlex justify="flex-start" gap=".6rem">
        <Icon color="basic" fontSize='small' />
        <div>{title}:</div>
      </BasicFlex>
      <CategoryText>
        {value}
      </CategoryText>
    </RepairInfoBar>
  );
};



const SelectRepair = ({ onRepairSelect, moveStep, category = {} }) => {
  const { data: repairs, isLoading } = useQuery({
    queryKey: ['repairs', category?.name, category?.vendor_id],
    queryFn: () => getRepairs(category?.name, category?.vendor_id),
  });
 
  const { data: repairList, pagination, setPagination, setSearchTerm, setLocalFilters, localFilters } = useSimpleTable({
    localData: repairs,
    rowsPerPage: 100,
    searchFields: ['name', 'category'],
    defaultSort: 'name',
  });
 
  const handleRepairClick = (repair) => {
    onRepairSelect(repair);
    moveStep();
  };
 
  const handleKeyDown = (event, repair) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleRepairClick(repair);
    }
  };
 
  const handleFilters = (val) => {
    if (val === 'all') {
      setLocalFilters(x => {
        delete x.in_house;
        return {...x};
      });
      return;
    }
    setLocalFilters(x => ({...x, in_house: val}));
  }
 
  return (
    <RepairMainContainer>
      <SearchInput
        onChange={(e) => setSearchTerm(e.target.value)}
        fieldsToSearch={['Repair Name', 'Category']}
      />
      <BasicFlex gap=".5rem" justify="flex-start" my="1rem">
        <FilterChip label="All" value="all" sf={handleFilters} lf={localFilters} />
        <FilterChip label="In House" value={true} sf={handleFilters} lf={localFilters} />
        <FilterChip label="Vendor" value={false} sf={handleFilters} lf={localFilters} />
      </BasicFlex>
 
      <RepairsContainer>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <TileSkeleton key={index} variant="rounded" height={92} />
            ))
          : repairList?.rows?.map((repair) => {
              const source = repair?.in_house ? SOURCE_CONFIG.inHouse : SOURCE_CONFIG.vendor;
              const SourceIcon = source.Icon;
              const duration = repair?.in_house
                ? `${repair.default_duration_in_minutes} min`
                : `${repair.default_estimated_time_to_complete} days`;
              const hasPrice = Number(repair?.default_price) > 0;
 
              return (
                <RepairTile
                  key={repair.repair_id}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleRepairClick(repair)}
                  onKeyDown={(e) => handleKeyDown(e, repair)}
                >
                  <RepairName title={repair.name}>{repair.name}</RepairName>
 
                  <PriceText muted={!hasPrice}>
                    {hasPrice ? formatCurrency(repair.default_price) : 'No default price'}
                  </PriceText>
 
                  <MetaRow>
                    <SourceIcon sx={{ fontSize: 18, color: repair?.in_house ? 'success.soft' : 'secondary.soft' }} />
                    <SourceText>{source.label}</SourceText>
                    <span>&middot;</span>
                    <AccessTimeRoundedIcon sx={{ fontSize: 13.5 }} />
                    <span>{duration}</span>
                    {repair?.category && (
                      <>
                        <span>&middot;</span>
                        <span>{repair.category}</span>
                      </>
                    )}
                  </MetaRow>
                </RepairTile>
              );
            })}
      </RepairsContainer>
    </RepairMainContainer>
  );
};

const SelectedRepair = ({ repair = {}, category = {} }) => {

  let { name, default_price, default_duration_in_minutes, default_estimated_time_to_complete, in_house } = repair;

  let location = in_house ? "In House" : "External";

  let duration = in_house ? `${default_duration_in_minutes} Min` : `${default_estimated_time_to_complete} Days`;

  return (
    <SelectedRepairContainer justify="flex-start" gap="2rem">
      <IconBox>
        <AutoFixHighRoundedIcon sx={{ fontSize: 28 }} color="basic" />
      </IconBox>

      <SelectedRepairInfoContainer>
        <SelectedRepairInfo className='name'>
          {repair.name}
        </SelectedRepairInfo>
        <SelectedRepairInfo justify="flex-start" gap="1rem">
         <AccessTimeIcon fontSize='small' /> {duration}
        </SelectedRepairInfo>
        <SelectedRepairInfo justify="flex-start" gap="1rem">
         <AttachMoneyIcon fontSize='small' /> {formatCurrency(repair.default_price)}
        </SelectedRepairInfo>
        <SelectedRepairInfo justify="flex-start" gap="1rem">
         <HouseRoundedIcon fontSize='small' /> {location}
        </SelectedRepairInfo>
      </SelectedRepairInfoContainer>

    </SelectedRepairContainer>
  )

}

const convertMediaToMainArray = (media, collection, key) => {
  let mediaArray = media?.map((file, index) => {
    let name = `${collection?.[key]}__${index}__${file?.name}`;
    const renamedFile = new File([file], name, { type: file.type });
    return renamedFile;
  })

  return mediaArray;
}


const MainForm = ({ repair = {}, category = {}, resetTotal, mode }) => {

  const { values: mainValues, setFieldValue } = useFormikContext() || {}; // main formik context

  let repairs = mainValues?.repairs || [];

  let in_house = repair?.in_house;

  const { handleClose } = useDialogForm() || {};

  const { formValues } = useFormData() || {};

  // which button was pressed — read synchronously in onSubmit
  const closeAfterSaveRef = useRef(false);

  const initialValues = {
    name: repair?.name,
    repair_task_uuid: uuidv4(),
    specialist_id: "",
    specialist_name: "",
    vendor_id: "",
    vendor_name: "",
    price: 0,
    cost: 0,
    duration_in_minutes: 0,
    estimated_time_to_complete: 0,
    priority: "normal",
    bill_to: "client",
    due_date: DateTime.local(),
    details: "",
    notes: "",
    in_house,
    media_urls: [],
    media: [],
  }

  const [initValues, setInitValues] = useState(initialValues);

  const validationSchema = Yup.object().shape({
    specialist_id: Yup.string().when('in_house', {
      is: true,
      then: schema => schema.required('Specialist is required'),
      otherwise: schema => schema.notRequired()
    }),
    vendor_id: Yup.string().when('in_house', {
      is: false,
      then: schema => schema.required('Vendor is required'),
      otherwise: schema => schema.notRequired()
    })
  })

  const { data: specialists } = useQuery({
    queryKey: ['specialists', repair?.repair_id, in_house],
    queryFn: () => findSpecialistsByRepair(repair?.repair_id, in_house),
    enabled: !!repair?.repair_id
  })

  useEffect(() => {
    if (specialists?.length === 1) {
      setInitValues({
        ...initialValues,
        specialist_id: specialists[0]?.specialist_id ? specialists[0]?.specialist_id : null,
        vendor_id: specialists[0]?.vendor_id ? specialists[0]?.vendor_id : null
      })
    } else {
      if (!in_house) {
        let vendor_id = category?.vendor_id;
        setInitValues({
          ...initialValues,
          vendor_id: vendor_id
        })
      }
    }
  }, [specialists])

  const onSubmit = async (userInfo = {}, { setSubmitting, setErrors, resetForm }) => {
    // capture the intent BEFORE any parent state updates are queued
    const shouldClose = closeAfterSaveRef.current;
    closeAfterSaveRef.current = false;

    const newRepair = {
      ...repair,
      ...userInfo,
      customer_name: formValues?.customer_name
    }

    // spread media files to main array
    if (userInfo?.media?.length) {
      let media = convertMediaToMainArray(userInfo?.media, userInfo, "repair_task_uuid");
      setFieldValue('media', (mainValues?.media || []).concat(media));
      delete newRepair.media;
    }

    setFieldValue('repairs', [...repairs, newRepair]);
    setSubmitting(false);
    resetForm();
    resetTotal();

    if (shouldClose && handleClose) handleClose();
  }

  return (
    <Formik
      initialValues={initValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ values, errors, submitForm }) => (
        <Form>
          {mode === "menu" ? <SelectedRepair repair={repair}></SelectedRepair> : null}
          <Grid container spacing={3}>

            {mode === "form" ? <>
              <Grid size={{xs: 6}}>
                <Field
                  formFieldType="text"
                  name="name"
                  label="Repair Name"
                />
              </Grid>

              <Grid size={{xs: 6}}>
                <Field
                  formFieldType="toggle"
                  name="in_house"
                  label="In-House/Vendor"
                  options={[{value: true, label: "In-House"}, {value: false, label: "Vendor"}]}
                />
              </Grid>

            </> : null}

            <Grid size={{xs: 6}}>
              <InputLabel>Select Specialist</InputLabel>
              {in_house ? <AutoCompleteFormik
              name = "specialist_id"
              url = "specialists"
              fieldName = "specialist_id"
              serverOptions={specialists}
              formUpdates = {[{name: `specialist_name`, field: "full_name"}, {name: "price", field: "price"}, {name: "duration_in_minutes", field: "duration_in_minutes"}, {name: "estimated_time_to_complete", field: "estimated_time_to_complete"}, {name: "cost", field: "cost"}]}
              displayField={"full_name"}
              /> : <AutoCompleteFormik
              name = "vendor_id"
              url = "vendors"
              fieldName = "vendor_id"
              serverOptions={specialists}
              formUpdates = {[{name: "vendor_name", field: "full_name"}, {name: "price", field: "price"}, {name: "estimated_time_to_complete", field: "estimated_time_to_complete"}, {name: "cost", field: "cost"}]}
              displayField={"full_name"}
              />}
            </Grid>
            <Grid size={{xs: 6}}>
              <Field
                formFieldType="text"
                name="price"
                label="Price"
              />
            </Grid>
            <Grid size={{xs: 12}}>
              <MediaZone />
            </Grid>
            <Grid size={{xs: 12}}>
              <Field 
                name="details" 
                label="Add Repair Details" 
                placeholder="Describe the details of the repair here..."
                formFieldType="text" 
                multiline 
                minRows={4} 
                type="text" 
              />
            </Grid>
            <Grid size={{xs: 12}}>
              <Field 
                name="notes" 
                label="Add Notes (Internal Only)" 
                formFieldType="text" 
                multiline 
                minRows={4} 
                type="text" 
              />
            </Grid>
            <Grid size={{xs: 12}} sx={{display: "flex", justifyContent: "flex-end", gap: "1.5rem"}}>
              <Button type="button" variant="outlined" startIcon={<SaveRoundedIcon />} onClick={() => {
                closeAfterSaveRef.current = true;
                submitForm();
              }}>Save &amp; Close</Button>
              <Button type="button" variant="contained" startIcon={<AddIcon />} onClick={() => {
                closeAfterSaveRef.current = false;
                submitForm();
              }}>Save &amp; Add Repair</Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}


const AddRepair = () => {

  const { values, setFieldValue } = useFormikContext() || {};

  const [mode, setMode] = useState("menu");

  const [activeCategoryTab, setActiveCategoryTab] = useState("categories");

  const toggleMode = () => {
    setMode(mode === "menu" ? "form" : "menu");
  }

  // console.log(values, "values");

  const steps = [
    // {
    //   id: 1,
    //   label: 'Select Category',
    //   component: Categories,
    // },
    {
      id: 1,
      label: 'Select Repair Type',
      component: SelectRepair,
      back: "To Repairs"
    },
    {
      id: 2,
      label: 'Complete Repair Details',
      // component: AddRepair,
      back: "To Categories",
    },
  ]

  const [step, setStep] = useState(1);
  const [category, setCategory] = useState(null);
  const [repair, setRepair] = useState(null);

  const moveStep = (dir = "next", num = 1) => {
    let newStep;
    if (dir === "next") {
      newStep = step + num
    } else {
      newStep = step - num
    }
    setTimeout(() => {
      setStep(newStep);
    }, 50);
  }

  const resetTotal = () => {
    setStep(1);
    setCategory(null);
    setRepair(null);
  }

  useEffect(() => {
    if (step === 1) {
      setCategory(null);
      setRepair(null);
    } else if (step === 2) {
      // setRepair(null);
    }
  }, [step])

  useEffect(() => {
    if (values?.finished_processing) {
      setFieldValue("repairs", []);
      setFieldValue("wig_id", "");
      setFieldValue("finished_processing", false)
    }
  }, [values?.finished_processing])

  return (
    <Grid size={{xs: 12}}>
      <Dialog
        toggle={<Button startIcon={<AddIcon />} variant="contained" size="large" disabled={!values?.wig_id}>Add Repair</Button>}
        title={<BasicFlex><div>Add Repair</div> 
        {/* <Button startIcon={<DriveFileRenameOutlineRoundedIcon />} variant="outlined" onClick={toggleMode} sx={{borderRadius: "10px", fontSize: "1.2rem"}}>{mode === "menu" ? "Add Custom Repair" : "Back to Menu"}</Button> */}
        </BasicFlex>}
        size="lg"
        useForm={true}
        disabled={!values?.wig_id}
      >
        {mode === "menu" ? <>
        {step > 1 ? <BackButton>
          <Button startIcon={<KeyboardReturnRoundedIcon />} onClick={() => moveStep("prev")} color="secondary" sx={{width: "fit-content"}}>Back {"To Repairs"}</Button>
        </BackButton> : null}

        <StepLabel justify="center" width="40rem">{steps[step - 1].id}. {steps[step - 1].label}</StepLabel>
        <MainContainer>

          {/* {step === 1 ? <Categories onCategorySelect={setCategory} moveStep={moveStep} activeTab={activeCategoryTab} setActiveTab={setActiveCategoryTab} /> : null} */}

          {step === 1 ? <SelectRepair onRepairSelect={setRepair} moveStep={moveStep} category={category} /> : null}

          {step === 2 ? <MainForm repair={repair} category={category} resetTotal={resetTotal} mode={mode} /> : null}

        </MainContainer>
        
        </> : <MainContainer><MainForm repair={repair} category={category} resetTotal={resetTotal} mode={mode} setMode={setMode} /></MainContainer>}
      </Dialog>
    </Grid>
  )
};

export default AddRepair;